import { render, staticRenderFns } from "./CurvesDialog.vue?vue&type=template&id=6b8c8fdc&scoped=true"
import script from "./CurvesDialog.vue?vue&type=script&lang=ts"
export * from "./CurvesDialog.vue?vue&type=script&lang=ts"
import style0 from "./CurvesDialog.vue?vue&type=style&index=0&id=6b8c8fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c8fdc",
  null
  
)

export default component.exports